export default "__VITE_ASSET__C8xP6nMK__"